 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"85352a93","chunk-09155df3":"52876540","chunk-09162720":"5fa9ec89","chunk-097e0872":"0c7e1b69","chunk-0e93a01c":"442fb25b","chunk-15cbd9fc":"2e1669b6","chunk-1bff95de":"f179eb0a","chunk-1c4705f4":"8ca9fc97","chunk-1dbc15a2":"5bbc8af9","chunk-21a76241":"fc50d07c","chunk-25d83ca8":"50a9f5cb","chunk-273b25e0":"24d5fcfe","chunk-27ef522e":"e144c0f8","chunk-2b21f014":"9a631459","chunk-2d0a463b":"9199a002","chunk-2d0ac931":"667708a1","chunk-2d0c073f":"017f6960","chunk-2d0c211b":"bd5d9530","chunk-2d0cf315":"8bdd27d5","chunk-2d0d43da":"edd6d8be","chunk-2d0d5c33":"d98bbfcf","chunk-2d0da04a":"620f425b","chunk-2d0e5812":"bc3079e1","chunk-2d213189":"2b11f265","chunk-2d217def":"a644b19b","chunk-2d217e6a":"9d5e5387","chunk-2d218068":"4ad272c9","chunk-2d21a9aa":"51f415cb","chunk-2d21b82b":"d751158c","chunk-2d21da73":"1dd5d4ed","chunk-2d222cca":"eaa1fa6a","chunk-2d224888":"01a8f4ab","chunk-2d225f5b":"61c4040c","chunk-2d22895d":"77161f63","chunk-2d23721e":"013295b1","chunk-2d237b00":"17ee064a","chunk-2d38fa7d":"1efb0747","chunk-2fc1d716":"545a02c0","chunk-30dd9750":"fb1fe266","chunk-3224a0d1":"7b6e9682","chunk-37f2300e":"d050c090","chunk-3a133bca":"e1738115","chunk-3baa0442":"ab5161cc","chunk-3ed29de3":"1276ef40","chunk-41c0f7a4":"1f657cbe","chunk-426f2f16":"3c5cd679","chunk-462c869e":"30dafc5b","chunk-47245a33":"ca01aa9b","chunk-4739acd0":"755847a2","chunk-4902bc08":"915921d7","chunk-53b1137a":"d405b5f3","chunk-541ea42d":"cb739116","chunk-54bbd082":"cddccb66","chunk-59d4c87c":"d2c0dc6c","chunk-5a8ac886":"36b654ba","chunk-5ff96a24":"1b5aefd4","chunk-6592bfe9":"bbd43ae5","chunk-742b3817":"ef2bee6e","chunk-7da8f817":"ed86e680","chunk-67cc1cbe":"855a816f","chunk-78d241a4":"be91a6bd","chunk-69eb8776":"c1fe688b","chunk-6d375f34":"42a4392c","chunk-7548ca2d":"3a3f1d69","chunk-79e15df5":"855b7230","chunk-2c9e61cc":"ee3a90af","chunk-2d2165e6":"0dd658df","chunk-2fe0cd64":"4931e4b4","chunk-44b43ecf":"ecdd00f0","chunk-46fcd58c":"0912417d","chunk-58bdb9d1":"25f9e871","chunk-58e9b24e":"d0ed6dfe","chunk-5ebccb43":"87e8cd77","chunk-64eb8496":"4736d0fb","chunk-73ec8fd6":"c07946fa","chunk-7439da51":"60f63c30","chunk-74e5fcde":"fdefae92","chunk-ac2f30ca":"f524e9e5","chunk-ddb6b8d6":"0bae4f68","chunk-79f1dac7":"ee5629fb","chunk-7a6d73b8":"b7b5f78e","chunk-7ba0f076":"0e6d06e5","chunk-858cd918":"a9541b7e","chunk-8bb7f81e":"1c060df2","chunk-9db0e87c":"2222fcb3","chunk-a9395c36":"eab30296","chunk-b2fea178":"55d2ad07","chunk-b37534f2":"cae1a924","chunk-d0e8aa0a":"143a0a2e","chunk-d8413eac":"70b6b623","chunk-e5275ddc":"44b054fc","chunk-eaa2b130":"81fc819c","chunk-fee109b6":"2bcc4e4d","polyfills-core-js":"12be3461","polyfills-dom":"662760da","stencil-polyfills-css-shim":"95cbdafc","stencil-polyfills-dom":"f9377d9e","chunk-2d0c9adc":"abac41ef","chunk-2d0c9758":"62f099a9","chunk-2d0b33e3":"2e69defc","chunk-2d0b9074":"cf6d8bbf","chunk-2d0b9280":"199a57da","chunk-2d0baac9":"ecbd8a2b","chunk-2d2376e6":"a05b70ee"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-15cbd9fc":1,"chunk-273b25e0":1,"chunk-27ef522e":1,"chunk-2b21f014":1,"chunk-2d38fa7d":1,"chunk-2fc1d716":1,"chunk-3224a0d1":1,"chunk-3a133bca":1,"chunk-3baa0442":1,"chunk-4902bc08":1,"chunk-742b3817":1,"chunk-67cc1cbe":1,"chunk-78d241a4":1,"chunk-2c9e61cc":1,"chunk-2fe0cd64":1,"chunk-44b43ecf":1,"chunk-46fcd58c":1,"chunk-58bdb9d1":1,"chunk-58e9b24e":1,"chunk-5ebccb43":1,"chunk-64eb8496":1,"chunk-73ec8fd6":1,"chunk-7439da51":1,"chunk-74e5fcde":1,"chunk-ac2f30ca":1,"chunk-ddb6b8d6":1,"chunk-7a6d73b8":1,"chunk-7ba0f076":1,"chunk-9db0e87c":1,"chunk-b2fea178":1,"chunk-b37534f2":1,"chunk-fee109b6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-15cbd9fc":"f75a5a99","chunk-1bff95de":"31d6cfe0","chunk-1c4705f4":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-273b25e0":"7a32ec63","chunk-27ef522e":"72382e31","chunk-2b21f014":"3a93fc6a","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0d5c33":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21b82b":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d224888":"31d6cfe0","chunk-2d225f5b":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-2d38fa7d":"448e19ba","chunk-2fc1d716":"bd9ae41d","chunk-30dd9750":"31d6cfe0","chunk-3224a0d1":"b6f7bd76","chunk-37f2300e":"31d6cfe0","chunk-3a133bca":"5ad40981","chunk-3baa0442":"941ec8bb","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-426f2f16":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-4902bc08":"86e111fd","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-6592bfe9":"31d6cfe0","chunk-742b3817":"06971aa6","chunk-7da8f817":"31d6cfe0","chunk-67cc1cbe":"794637a5","chunk-78d241a4":"8ffcee5e","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-7548ca2d":"31d6cfe0","chunk-79e15df5":"31d6cfe0","chunk-2c9e61cc":"89fe157d","chunk-2d2165e6":"31d6cfe0","chunk-2fe0cd64":"0b8faec7","chunk-44b43ecf":"117cb041","chunk-46fcd58c":"0e574611","chunk-58bdb9d1":"51e4498b","chunk-58e9b24e":"4548b13c","chunk-5ebccb43":"793ec6d0","chunk-64eb8496":"8d6e9e58","chunk-73ec8fd6":"f9c4778f","chunk-7439da51":"793ec6d0","chunk-74e5fcde":"5bb027bd","chunk-ac2f30ca":"950cdb87","chunk-ddb6b8d6":"d925a677","chunk-79f1dac7":"31d6cfe0","chunk-7a6d73b8":"08c09114","chunk-7ba0f076":"70947f9e","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-9db0e87c":"17c43530","chunk-a9395c36":"31d6cfe0","chunk-b2fea178":"bb94c1a4","chunk-b37534f2":"cc0fcfd9","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","chunk-fee109b6":"7e61c1e3","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0c9adc":"31d6cfe0","chunk-2d0c9758":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9074":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d2376e6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
